module.exports = __webpack_public_path__ + "img/img-testimonios.fd361bd7.png";